import { Instance, types } from 'mobx-state-tree';

const RubricLevel = types.model('RubricLevel', {
	id: types.identifierNumber,
	title: types.string,
	description: types.string,
	percent_from: types.number,
	percent_to: types.number,
});

export default RubricLevel;

export interface IRubricLevelModel extends Instance<typeof RubricLevel> {}
